module.exports = {
          srcSet: __webpack_public_path__ + "af200777.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "af200777.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "af200777.jpg",
          toString:function(){return __webpack_public_path__ + "af200777.jpg"},
          
          width: 330,
          height: 200
        }